import {Nir} from "../../nir/nir";
import {Caisse} from '../../caisse';

export class Situation {
  public grand_regime_nom: string = '';

  constructor(
    public nir: Nir,
    public nature_assurance: string,
    public situation_particuliere: string,
    public tiers_payant_reglementaire: string,
    public destinataire_reglement: string,
    public organisme_complementaire: string,
    public type_contrat: string,
    public taux_applicable_prestation: string,
    public justificatif_exo: string,
    public grand_regime: string,
    public organisme: string,
    public entite_gestion: string,
    public date_maternite: string
  ){
  }

  private static normalizeDate(date: string){
    return date.substr(8, 2) + date.substr(5, 2) + date.substr(0,4)
  }

  public static create(datas: any){
    console.log(datas);
    let situation: Situation;
    if (datas.data.couverture && !datas.data.couverture[0]){
      situation = new Situation(
          new Nir(datas.nir.num, datas.nir.key),
          datas.data.couverture.contrats.nature_assurance,
          datas.data.beneficiaire.situation_particuliere,
          datas.data.couverture.contrats.cadre_reglement ? "OUI": "NON",
          null,
          null,
          null,
          datas.data.cadre.execution.service.rmb.part.tux,
          datas.data.cadre.execution.service.rmb.exo,
          datas.data.couverture.grand_regime,
          datas.data.couverture.organisme,
          datas.data.couverture.entite_gestion,
          datas.data.couverture.contexte.date_maternite ? this.normalizeDate(datas.data.couverture.contexte.date_maternite) : null
      );
    } else {
      situation = new Situation(
          new Nir(datas.nir.num, datas.nir.key),
          datas.data.couverture[0].contrats.nature_assurance,
          datas.data.beneficiaire.situation_particuliere,
          datas.data.couverture[0].contrats.cadre_reglement ? "OUI": "NON",
          datas.data.couverture[1] ? datas.data.couverture[1].contexte.cadre_reglement : null,
          datas.data.couverture[1] ? datas.data.couverture[1].id_org : null,
          datas.data.couverture[1] ? datas.data.couverture[1].contrats.contrat : null,
          datas.data.cadre.execution.service.rmb.part.tux,
          datas.data.cadre.execution.service.rmb.exo,
          datas.data.couverture[0].grand_regime,
          datas.data.couverture[0].organisme,
          datas.data.couverture[0].entite_gestion,
          datas.data.couverture[0].contexte.date_maternite ? this.normalizeDate(datas.data.couverture[0].contexte.date_maternite) : null
      );
    }
    if (situation.grand_regime  != null) {
      const caisse = Caisse.caisses.get(situation.grand_regime);
      if (caisse != null) {
        situation.grand_regime_nom = caisse.name;
      }
    }
    return situation;
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/situation/situation.ts